import { DischargedFrame } from 'components/common/types/Deal.types';

export const getDischargedFrameIdsSet = (dischargedFrameIds: DischargedFrame[]): Set<string> =>
  new Set(dischargedFrameIds?.map(({ assetId }) => assetId));
